export default __webpack_public_path__ + "static/media/dashboard.b6df0a10.svg";